import { Stack } from "@mui/material";
import Calendar from "../../components/displays/reservations/Calendar";

export default function FullPageCalendar() {
  return (
    <Stack>
      <Calendar height="85vh" />
    </Stack>
  );
}